import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './InscriptionsPage.module.css';

interface FormData {
  Firstname: string;
  'Lastname Plain': string;
  'Company Plain': string;
  'Fonction Plain': string;
  Email: string;
  'T Phone': string;
  'RGPD Checkbox': boolean;
  Event: string;
}

const InscriptionsPage: React.FC = () => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    Firstname: '',
    'Lastname Plain': '',
    'Company Plain': '',
    'Fonction Plain': '',
    Email: '',
    'T Phone': '',
    'RGPD Checkbox': false,
    Event: 'B2B_05',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const payload = {
      name: 'B2B Inscriptions',
      data: {
        Firstname: formData.Firstname,
        Lastname: formData['Lastname Plain'],
        Company: formData['Company Plain'],
        Fonction: formData['Fonction Plain'],
        Email: formData.Email,
        Phone: formData['T Phone'],
        RGPD: formData['RGPD Checkbox'] ? 'true' : 'false',
        Event: formData.Event,
      },
    };

    try {
      const response = await fetch('https://flows.butterflyagency.io/webhook/webflow-forms-submisssion', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ payload }),
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        alert('Une erreur est survenue. Veuillez réessayer.');
      }
    } catch (error) {
      alert('Une erreur est survenue. Veuillez réessayer.');
    }
  };

  return (
    <div>
      <Helmet>
        <title>Brands 2 Buyers | SUMMER Edition - Inscriptions</title>
        <meta name="description" content="Inscriptions pour Brands 2 Buyers | SUMMER Edition, le 25 juin 2026 à Paris. L'événement majeur en France dédié à la transformation digitale et à l'innovation dans le commerce B2B." />
        <meta property="og:title" content="Brands 2 Buyers | SUMMER Edition - Inscriptions" />
        <meta property="og:description" content="Inscriptions pour Brands 2 Buyers | SUMMER Edition, le 25 juin 2026 à Paris. L'événement majeur en France dédié à la transformation digitale et à l'innovation dans le commerce B2B." />
        <meta property="og:image" content="https://brands2buyers.io/assets/images/logo.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Brands 2 Buyers | SUMMER Edition - Inscriptions" />
        <meta name="twitter:description" content="Inscriptions pour Brands 2 Buyers | SUMMER Edition, le 25 juin 2026 à Paris. L'événement majeur en France dédié à la transformation digitale et à l'innovation dans le commerce B2B." />
        <meta name="twitter:image" content="https://brands2buyers.io/assets/images/logo.png" />
      </Helmet>
      {/* Hero Banner */}
      <section className={styles.hero}>
        <div className={styles.heroInner}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>INSCRIPTIONS</h1>
            <p className={styles.heroEdition}>SUMMER Edition — 25 JUIN 2026</p>
          </div>
          <div className={styles.heroImageWrapper}>
            <img
              src="/assets/images/evenement-hero-illustration.jpg"
              alt="Brands2Buyers SUMMER Edition Inscriptions"
              className={styles.heroImage}
            />
          </div>
        </div>
      </section>

      {/* Sponsor Section */}
      <section className={styles.sponsorSection}>
        <p className={styles.sponsorLabel}>En partenariat avec</p>
        <img
          src="/assets/images/sponsor-dataenso.png"
          alt="Data Enso"
          className={styles.sponsorLogo}
        />
      </section>

      {/* Form Section */}
      <section className={styles.formSection}>
        <div className={styles.formContainer}>
          <h2 className={styles.formHeading}>Inscription pour Brands 2 Buyers | SUMMER Edition</h2>
          <p className={styles.description}>
            Rejoignez-nous le <strong>25 juin 2026</strong> en format afterwork
            à Paris pour <strong>Brands 2 Buyers | SUMMER Edition</strong>, l'événement majeur en
            France dédié à la transformation digitale et à l'innovation dans le
            commerce B2B !
          </p>
          <p className={styles.subtitle}>RÉSERVÉ AUX RETAILERS</p>

          {submitted ? (
            <div className={styles.successMessage}>
              <p>Merci ! Votre demande a bien été prise en compte ! Nous vous confirmerons rapidement la prise en compte de votre inscription.</p>
            </div>
          ) : (
          <form name="B2B Inscriptions" onSubmit={handleSubmit}>
            <input type="hidden" name="Event" value="B2B_05" />
            <label className={styles.label} htmlFor="Firstname">
              Prénom
            </label>
            <input
              className={styles.input}
              type="text"
              id="Firstname"
              name="Firstname"
              value={formData.Firstname}
              onChange={handleChange}
              required
            />

            <label className={styles.label} htmlFor="Lastname Plain">
              Nom
            </label>
            <input
              className={styles.input}
              type="text"
              id="Lastname Plain"
              name="Lastname Plain"
              value={formData['Lastname Plain']}
              onChange={handleChange}
              required
            />

            <label className={styles.label} htmlFor="Company Plain">
              Société
            </label>
            <input
              className={styles.input}
              type="text"
              id="Company Plain"
              name="Company Plain"
              value={formData['Company Plain']}
              onChange={handleChange}
              required
            />

            <label className={styles.label} htmlFor="Fonction Plain">
              Fonction
            </label>
            <input
              className={styles.input}
              type="text"
              id="Fonction Plain"
              name="Fonction Plain"
              value={formData['Fonction Plain']}
              onChange={handleChange}
              required
            />

            <label className={styles.label} htmlFor="Email">
              Email Professionnel
            </label>
            <input
              className={styles.input}
              type="email"
              id="Email"
              name="Email"
              value={formData.Email}
              onChange={handleChange}
              required
            />

            <label className={styles.label} htmlFor="T Phone">
              Téléphone
            </label>
            <input
              className={styles.input}
              type="tel"
              id="T Phone"
              name="T Phone"
              value={formData['T Phone']}
              onChange={handleChange}
            />

            <div className={styles.checkboxWrapper}>
              <input
                className={styles.checkbox}
                type="checkbox"
                id="RGPD Checkbox"
                name="RGPD Checkbox"
                checked={formData['RGPD Checkbox']}
                required
                onChange={handleChange}
              />
              <label className={styles.checkboxLabel} htmlFor="RGPD Checkbox">
                En communiquant mes coordonnées, je confirme que j'ai lu et que
                j'accepte et partage mes données personnelles avec B2B et ses
                partenaires. En fournissant mes coordonnées, j'autorise les
                partenaires et famille d'entreprises à me contacter.
              </label>
            </div>

            <button className={styles.submitButton} type="submit">
              VALIDER MON INSCRIPTION
            </button>
          </form>
          )}
        </div>
      </section>
    </div>
  );
};

export default InscriptionsPage;
